import { useState } from 'react';

type Phase = 'waiting' | 'loading' | 'settled';

/**
 * True until the first fetch after mount has come back. Refetches (e.g. on a
 * filter change) keep the last content on screen instead of flashing skeletons.
 *
 * @param {boolean} loading the fetch's loading flag
 * @returns {boolean} whether to show the first-load skeleton
 */
export default function useFirstLoad (loading: boolean) {
  const [phase, setPhase] = useState<Phase>('waiting');

  if (phase === 'waiting' && loading) setPhase('loading');
  if (phase === 'loading' && !loading) setPhase('settled');

  return phase !== 'settled';
}
